import { http } from '../util/http';

export default class LeadService {
	static get() {
		return http.get(`/lead-tracking`);
	}

	static search(query) {
		return http.get(`/lead-tracking/search?id=${query}`);
	}

	static stats(query) {
		return http.get(`/lead-tracking/stats?id=${query}`);
	}
}
